import React from 'react';

import { Divider, Typography } from '@mui/material';

type PropsType = {
    label: React.ReactNode,
    icon?: React.ReactNode,
    marginTop?: number,
    marginBottom?: number,
    onClick?: () => void
};

const SectionDivider: React.FC<PropsType> = (props) => {
    const {
        label,
        icon,
        marginTop = 4,
        marginBottom = 2,
        onClick
    } = props;

    return (
        <Divider
            onClick={onClick}
            sx={{
                marginTop,
                marginBottom,
                cursor: onClick ? 'pointer' : 'default'
            }}
        >
            <Typography variant="overline" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {icon}
                {label}
            </Typography>
        </Divider>
    );
};

export default SectionDivider;
